"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import React, {
  cloneElement,
  useRef,
  useContext,
  forwardRef,
  useImperativeHandle
} from "react";
import classNames from "classnames";
import { OptionMenuClassName, OptionMenuContext } from "./OptionMenu";
import { Tick, Delete } from "../../icons";
import { OptionMenuItemsContext } from "./OptionMenuItemsContext";
import { useLayoutEffect } from "../../../utils/useIsomorphicLayoutEffect";
const OptionMenuItemComponent = ({
  closeOnClick = true,
  disabled,
  onClick,
  destructive,
  selected,
  icon,
  className,
  children,
  innerRef,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  ["aria-describedby"]: ariaDescribedBy
}) => {
  const menuItemRef = useRef(null);
  useImperativeHandle(
    innerRef,
    () => menuItemRef.current
  );
  const { registerMenuItem, unregisterMenuItem, menuRef } = useContext(OptionMenuItemsContext);
  const { close, buttonRef } = useContext(OptionMenuContext);
  useLayoutEffect(() => {
    if (!disabled) {
      registerMenuItem(menuItemRef);
    }
    return () => {
      unregisterMenuItem(menuItemRef);
    };
  }, [disabled]);
  const handleClick = (event) => {
    var _a;
    if (closeOnClick) {
      close == null ? void 0 : close();
    }
    if (event.nativeEvent.detail === 0 && closeOnClick) {
      (_a = buttonRef.current) == null ? void 0 : _a.focus();
    }
    onClick == null ? void 0 : onClick(event);
  };
  const handleMouseUp = () => {
    var _a;
    (_a = menuRef.current) == null ? void 0 : _a.focus();
  };
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: classNames(
        `${OptionMenuClassName}__item`,
        { [`${OptionMenuClassName}__item--destructive`]: destructive },
        className
      ),
      onClick: !disabled ? handleClick : void 0,
      role: selected !== void 0 ? "menuitemradio" : "menuitem",
      "aria-checked": selected,
      disabled,
      ref: menuItemRef,
      onMouseUp: handleMouseUp,
      onMouseEnter,
      onMouseLeave,
      onFocus,
      onBlur,
      "aria-describedby": ariaDescribedBy
    },
    !!icon && cloneElement(icon, { className: `${OptionMenuClassName}__icon` }),
    /* @__PURE__ */ React.createElement("span", { className: `${OptionMenuClassName}__text` }, children),
    selected && /* @__PURE__ */ React.createElement(Tick, { className: `${OptionMenuClassName}__tick` }),
    destructive && /* @__PURE__ */ React.createElement(Delete, { className: `${OptionMenuClassName}__delete` })
  );
};
const OptionMenuItem = forwardRef(function button(props, ref) {
  return /* @__PURE__ */ React.createElement(OptionMenuItemComponent, __spreadValues({ innerRef: ref }, props));
});
export default OptionMenuItem;
